<template>
  <div class="row">
    <div class="form-group col-md-12">
      <div class="card">
        <div class="card-header">
          <span v-if="isCompanyPage" class="align-middle">{{ $t('project.company.form.entrepreneur.title') }}</span>
          <span v-if="!isCompanyPage" class="align-middle">{{ $t('entrepreneur.form.company.title') }}</span>
          
          <div class="float-right"  v-if="compMode != CRUDMODE.READ">
            <a href="#entrepreneur" name="entrepreneur" @click="addEntrepreneur"><span class="fa fa-plus fa-lg"></span></a>
          </div>
          <div class="float-right"  v-else>
            <ul class="nav nav-pills">
              <li class="nav-item">
                <a :class="visualization == 1 ? 'nav-link active' : 'nav-link'" href="#companyEntrepreneur1" name="companyEntrepreneur1" @click="setVisualisation(1)">Détails entrepreneur</a>
              </li>
              <li class="nav-item">
                <a :class="visualization == 2 ? 'nav-link active' : 'nav-link'" href="#companyEntrepreneur2" name="companyEntrepreneur2" @click="setVisualisation(2)">Progression salariale</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="card-body">
          <div class="row" v-if="compMode != CRUDMODE.READ || !isCompanyPage">

            <table id="dataTableEntrepreneurCompany" width="100%" cellspacing="0" 
                class="table table-bordered table-striped dataTable" >
             <thead>
                <tr>
                  <th v-if="isCompanyPage" >{{ $t('project.company.form.entrepreneur.name') }}</th>
                  <th v-if="!isCompanyPage" >{{ $t('entrepreneur.form.company.title') }}</th>
                  <th width="200">{{ $t('project.company.form.entrepreneur.function') }}</th>
                  <th width="200">{{ $t('project.company.form.entrepreneur.salary') }}</th>
                  <th width="200">{{ $t('project.company.form.entrepreneur.since') }}</th>
                  <th width="50"></th>
                </tr>
              </thead>
              <tfoot>
                <tr>
                  <th>{{ $t('project.company.form.entrepreneur.totalSalary') }}</th>
                  <th></th>
                  <th width="200"><input type=text v-model="total" v-money="{}" class="form-control" disabled /></th>
                  <td></td>
                  <th></th>
                </tr>
                 <tr>
                  <th v-if="isCompanyPage" >{{ $t('project.company.form.entrepreneur.name') }}</th>
                  <th v-if="!isCompanyPage" >{{ $t('entrepreneur.form.company.title') }}</th>
                  <th width="200">{{ $t('project.company.form.entrepreneur.function') }}</th>
                  <th width="200">{{ $t('project.company.form.entrepreneur.salary') }}</th>
                  <th width="200">{{ $t('project.company.form.entrepreneur.since') }}</th>
                  <th width="50" ></th>
                </tr>
              </tfoot>
              <tbody>
                <tr class="odd" v-if="companyEntrepreneurs.length == 0">
                    <td valign="top" colspan="5" class="dataTables_empty">Aucune donnée disponible dans le tableau</td>
                </tr>

                <tr v-for="(item, index) in sortAndFilter(companyEntrepreneurs)" v-bind:data-id="item.id" :key="item.id">
                  
                  <td v-if="!isCompanyPage">
                   
                    <multiselect v-model="item.company" id="ajax" :custom-label="companyLabel" 
                      track-by="id" :placeholder="$t('entrepreneur.form.company.title')" open-direction="bottom" 
                      :options="companys" :multiple="false" :searchable="true" :loading="isLoading" 
                      :internal-search="false" :clear-on-select="true" :close-on-select="true" 
                      :options-limit="300" :max-height="600" :show-no-results="true" 
                      :hide-selected="true" @search-change="asyncFindCompanys"
                      :select-label="$t('project.company.form.entrepreneur.select')">

                      <span slot="noResult">{{ $t('project.company.form.entrepreneur.notFound') }} </span>
                    </multiselect>

                  </td>
                  
                  <td v-if="isCompanyPage">
                    
                    <multiselect v-model="item.entrepreneur" id="ajax" :custom-label="entrepreneurLabel" 
                      track-by="id" :placeholder="$t('project.company.form.entrepreneur.name')" open-direction="bottom" 
                      :options="entrepreneurs" :multiple="false" :searchable="true" :loading="isLoading" 
                      :internal-search="false" :clear-on-select="true" :close-on-select="true" 
                      :options-limit="300" :max-height="600" :show-no-results="true" 
                      :hide-selected="true" @search-change="asyncFind"
                      :select-label="$t('project.company.form.entrepreneur.select')">

                      <span slot="noResult">{{ $t('project.company.form.entrepreneur.notFound') }} </span>
                    </multiselect>

                  </td>
                  <td>
                      <multiselect v-model="item.function" id="ajax" 
                        :placeholder="$t('project.company.form.entrepreneur.function') "
                        open-direction="bottom" :options="functions" :multiple="false" :searchable="true" :loading="isLoading" 
                        :internal-search="false" :clear-on-select="true" :close-on-select="true" 
                        :options-limit="300" :max-height="600" :show-no-results="false" 
                        :hide-selected="true" @search-change="asyncFindFunction"
                        :select-label="$t('project.company.form.entrepreneur.select')"
                        :tag-placeholder="$t('project.company.form.entrepreneur.add')"
                        :taggable="true" @tag="t => addTag(index, t)">
                      </multiselect>
                    </td>
                  <td>
                      <input v-model.trim="item.salary" v-money="{}" name="salary" type="text" class="form-control" id="salary"  />
                  </td>
                  <td>
                    <moment-date-picker v-model="item.since" :required="true"></moment-date-picker>
                  </td>
                  <td align=center >
                    <a class="text-danger" v-if="compMode != CRUDMODE.READ" v-bind:title="$t('form.delete_button')" href="#entrepreneur" v-on:click="removeEntrepreneur(index)">
                        <span class="fa fa-lg fa-trash"></span>
                    </a>
                    <span v-if="isLastSalary(item)" class="fa fa-lg fa-certificate text-success" :title="$t('project.company.form.entrepreneur.lastSalary')"></span>
                    <span v-else class="fa fa-lg fa-certificate text-secondary" :title="$t('project.company.form.entrepreneur.oldSalary')"></span>
                  </td> 
                 
                </tr>
              </tbody>
            </table>

          </div>

          <div v-if="compMode == CRUDMODE.READ && isCompanyPage">
            <ul class="item-view" v-if="visualization == 1">
              <li v-if="companyEntrepreneurs == null || companyEntrepreneurs.length == 0">
                {{ $t("form.aucun_donne") }}
              </li>
              <li v-for="item in filterActive(companyEntrepreneurs)" v-bind:data-id="item.id" :key="item.id">

                <div class="row">
                  <div class="form-group col-md-6">
                    <label>{{ $t('project.company.form.entrepreneur.name') }}</label>
                    <div class="input-group mb-3">
                      <input :value="item.entrepreneur.familyName +', '+ item.entrepreneur.name" type=text class="form-control" disabled />
                      
                      <div class="input-group-append">
                        <button class="btn btn-outline-secondary" v-on:click.stop="showPersonPage(item)" type="button"><span class="fa fa-lg fa-link"></span></button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-3">
                    <label>{{ $t('project.company.form.entrepreneur.function') }}</label>
                    <input type=text class="form-control" v-model="item.function" disabled />
                  </div>
                  <div class="form-group col-md-3">
                    <label>{{ $t('project.company.form.entrepreneur.salary') }}</label>
                    <input type=text class="form-control" v-model="item.salary" disabled />
                  </div>
                </div>

                <div class="row" >
                  <div class="form-group col-md-3">
                    <label>{{ $t('entrepreneur.form.education') }}*</label>
                    <input :value="item.entrepreneur.education" name="education" type="text" class="form-control" disabled />
                  </div>
                  <div class="form-group col-md-3">
                    <label>{{ $t('entrepreneur.form.sex') }}*</label>
                    <input :value="item.entrepreneur.sexText" name="sex" type="text" class="form-control" disabled />
                  </div>
                  <div class="form-group col-md-3">
                    <label>{{ $t('entrepreneur.form.language') }}*</label>
                    <input :value="item.entrepreneur.language" name="language" type="text" class="form-control" disabled />
                  </div>
                  <div class="form-group col-md-3">
                    <label>{{ $t('entrepreneur.form.birthdate') }}*</label>
                    <input :value="item.entrepreneur.birthdate | formatDate" name="birthdate" type="text" class="form-control" disabled />
                  </div>
                </div>
                <div class="row" >
                  <div class="form-group col-md-3">
                    <label>{{ $t('entrepreneur.form.email') }}</label>
                    <input :value="item.entrepreneur.email" name="email" type="text" class="form-control" disabled />
                  </div>
                  <div class="form-group col-md-3">
                    <label>{{ $t('entrepreneur.form.cellphone') }}*</label>
                    <input :value="item.entrepreneur.cellphone" name="cellphone" type="text" class="form-control" disabled />
                  </div>
                  <div class="form-group col-md-3">
                    <label>{{ $t('entrepreneur.form.phone') }}*</label>
                    <input :value="item.entrepreneur.phone" name="phone" type="text" class="form-control" disabled />
                  </div>
                  <div class="form-group col-md-3">
                    <label>{{ $t('entrepreneur.form.officePhone') }}*</label>
                    <input :value="item.entrepreneur.officePhone + (item.entrepreneur.officePhoneExtension != null ? '#' + item.entrepreneur.officePhoneExtension : '')" name="officePhone" disabled type="text" class="form-control" />
                  </div>
                </div>
                <div class="row" >
                  <div class="form-group col-md-3">
                    <label>{{ $t('entrepreneur.form.numberEnterpriseAsManager') }}</label>
                    <input :value="item.entrepreneur.numberEnterpriseAsManager" name="numberEnterpriseAsManager" type="text" class="form-control" disabled />
                  </div>
                  <div class="form-group col-md-9">
                    <label>{{ $t('entrepreneur.form.social.title') }}*</label>
                    <input :value="getSocial(item.entrepreneur.social)" name="socialNetwork" type="text" class="form-control" disabled />
                  </div>
                </div>

              </li>
            </ul>
            <div class="form-group col-md-3 float-right total-salaire" v-if="compMode == CRUDMODE.READ && isCompanyPage && visualization == 1">
              <label>{{ $t('project.company.form.entrepreneur.totalSalary') }}</label>
              <input :value="total" name="totalSalary" type="text" class="form-control" disabled />
            </div>
            
            <div v-if="visualization == 2">
              <div id="salaryPivot"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    CompanyServiceClient,
    ProjectServiceClient,
    CompanyEntrepreneurServiceClient,
    EntrepreneurServiceClient,
    CompanyEntrepreneurDto,
  } from '../../shared/service-clients/service-clients'
  import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
  import CrudMixin from '../../shared/Mixin/CrudMixin'
  import Multiselect from 'vue-multiselect'
  import MomentDatePicker from '../../shared/components/MomentDatePicker'

  import 'pivottable'

  export default {
    name: 'CompanyEntrepreneur',
    props: {
      companyEntrepreneurs: {},
      isCompanyPage: {
        type: Boolean,
        default: true,
      },
      viewMode: {
        default: false,
      },
    },
    data() {
      return {
        entrepreneurs: [],
        functions: [],
        companys: [],
        isLoading: false,
        visualization: 1,
        pivotalData: [],
      }
    },
    mixins: [CrudMixin],
    mounted: function() {
      let self = this
      setTimeout(function() {
        self.fetchData()
        self.setMode()
      }, 1000)
    },
    computed: {
      employeeCountTotal: function() {
        return 0
      },
      total: {
        get() {
          let groupedData = []
  
          if (this.isCompanyPage) {
            groupedData = _.chain(this.companyEntrepreneurs)
              .filter(x => x.entrepreneur != null)
              .groupBy(x => x.entrepreneur.id)
              .map((value, key) => ({entrepreneur: key, salary: _.maxBy(value, 'since').salary}))
              .value()
          } else {
            groupedData = _.chain(this.companyEntrepreneurs)
              .filter(x => x.company != null)
              .groupBy(x => x.company.id)
              .map((value, key) => ({company: key, salary: _.maxBy(value, 'since').salary}))
              .value()
          }

          return _.sumBy(groupedData, function(o) {
            if (o.salary != null) {
              return parseFloat(o.salary.toString().replace(',', ''))
            } else {
              return 0
            }
          })
        },
        set(val) {},
      },
    },
    methods: {
      setVisualisation: function(visualization) {
        this.visualization = visualization
  
        if (this.visualization == 2) {
          if (this.pivotalData.length == 0) {
            this.pivotalData = _.chain(this.companyEntrepreneurs)
              .map(value => ({
                Entrepreneur: value.entrepreneur.title + ' ' + value.entrepreneur.familyName + ', ' + value.entrepreneur.name,
                Salaire: value.salary,
                Date: value.since.format('DD-MM-YYYY'),
              }))
              .value()
          }

          let self = this
  
          setTimeout(function() {
            var average = $.pivotUtilities.aggregatorTemplates.average
            var numberFormat = $.pivotUtilities.numberFormat
            var intFormat = numberFormat({digitsAfterDecimal: 2})

            $('#salaryPivot').pivot(self.pivotalData, {
              rows: ['Entrepreneur'],
              cols: ['Date'],
              aggregator: average(intFormat)(['Salaire']),
            })
            $('.pvtTable').addClass('table table-bordered table-striped dataTable')
            $('.pvtTotalLabel').text('Moyenne')
          }, 500)
        }
      },
      filterActive: function(companyEntrepreneurs) {
        if (companyEntrepreneurs == null || companyEntrepreneurs.length == 0) return []
        return _.chain(companyEntrepreneurs)
          .filter(x => x.entrepreneur != null)
          .groupBy(x => x.entrepreneur.id)
          .map((value, key) => _.maxBy(value, 'since'))
          .value()
      },
      getSocial: function(social) {
        if (social == null || social.socialNetworks == null) return ''
        return social.socialNetworks.join(',')
      },
      isLastSalary: function(item) {
        let lastSalary = []
  
        if (this.isCompanyPage) {
          if (item.since == null || item.entrepreneur == null) return false
          lastSalary = _.chain(this.companyEntrepreneurs)
            .filter(x => x.entrepreneur != null && x.entrepreneur.id == item.entrepreneur.id)
            .maxBy('since')
            .value()
        } else {
          if (item.since == null || item.company == null) return false
          lastSalary = _.chain(this.companyEntrepreneurs)
            .filter(x => x.company != null && x.company.id == item.company.id)
            .maxBy('since')
            .value()
        }

        if (lastSalary == null || lastSalary.length == 0) return true

        return moment(item.since).isSameOrAfter(moment(lastSalary.since))
      },
      sortAndFilter: function(companyEntrepreneurs) {
        return companyEntrepreneurs
      },
      showPersonPage: function(item) {
        let routeData = this.$router.resolve({path: '/entrepreneurs/view/' + item.entrepreneurId})
        window.open(routeData.href, '_blank')
      },
      fetchData: function() {},
      addEntrepreneur: function() {
        let dto = new CompanyEntrepreneurDto()
        dto.init({since: Date()})
        this.companyEntrepreneurs.push(dto)
      },
      removeEntrepreneur: function(index) {
        this.companyEntrepreneurs.splice(index, 1)
      },

      asyncFind: function(query) {
        this.isLoading = true
  
        let service = ServiceFactory.create(EntrepreneurServiceClient)
        let self = this

        service.getAutocomplete(query).then(response => {
          self.entrepreneurs = response
          self.isLoading = false
        })
      },
      asyncFindFunction: function(query) {
        this.isLoading = true
  
        let service = ServiceFactory.create(CompanyEntrepreneurServiceClient)
        let self = this

        service.getFunctionAutoComplet(query).then(response => {
          self.functions = this._.map(response, function(item) {
            return item
          })

          if (!this._.some(self.functions, 'PDG')) self.functions.push('PDG')

          self.isLoading = false
        })
      },

      asyncFindCompanys: function(query) {
        this.isLoading = true
        let self = this

        let service = ServiceFactory.create(ProjectServiceClient)
        service.getAutocomplete(undefined, 1, query).then(response => {
          //self.projects = response
          //service.getAutocomplete(undefined, query).then(response => {
          self.companys = response
          self.isLoading = false
        })
      },

      entrepreneurLabel: function(obj) {
        return obj.familyName + ', ' + obj.name
      },
      companyLabel: function(obj) {
        return obj.entreprise.name
      },
      addTag: function(index, tag) {
        this.companyEntrepreneurs[index].function = tag
      },
    },
    components: {
      multiselect: Multiselect,
      'moment-date-picker': MomentDatePicker,
    },
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .total-salaire {
    border-top: 1px solid rgba(0,0,0,.525);
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/projects/CompanyEntrepreneur.vue